import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ApplypointPage } from './applypoint';

@NgModule({
  declarations: [
    ApplypointPage,
  ],
  imports: [
    IonicPageModule.forChild(ApplypointPage),
  ],
})
export class ApplypointPageModule {}



// WEBPACK FOOTER //
// ./src/pages/applypoint/applypoint.module.ts